import axiosInstance from "../config/axios.config";

/*
 * Stock transfers move batches between facilities in the same organisation.
 *
 * Every call is scoped by the `facility` header, which axios.config.js already
 * attaches - it identifies the ACTING facility and therefore what the caller is
 * allowed to do: the sender may cancel, the receiver may confirm or reject.
 * The sending facility is never sent in the body for that reason.
 */

export const getPharmacyTransfersApi = (params) =>
  axiosInstance.get(`pharmacy/transfers/?${params}`);

export const getPharmacyTransferApi = (id) =>
  axiosInstance.get(`pharmacy/transfers/${id}/`);

/** `to_facility` is the destination; the source comes from the facility header. */
export const createPharmacyTransferApi = (payload) =>
  axiosInstance.post("pharmacy/transfers/", payload);

/** Receiving facility acknowledges the stock physically arrived. */
export const confirmPharmacyTransferApi = (id) =>
  axiosInstance.post(`pharmacy/transfers/${id}/confirm/`);

/** Receiving facility declines; `rejection_reason` is required. */
export const rejectPharmacyTransferApi = (id, payload) =>
  axiosInstance.post(`pharmacy/transfers/${id}/reject/`, payload);

/** Sending facility withdraws its own request before the receiver acts. */
export const cancelPharmacyTransferApi = (id) =>
  axiosInstance.post(`pharmacy/transfers/${id}/cancel/`);
